import React from "react";
import { Link } from "gatsby";

import SiteLogo from "../assets/images/hsd-logo.svg";

const Footer = ({ siteTitle }) => {
  return (
    <footer className="main-footer">
      <div className="main-footer-container">
        <div className="footer-logo">
          <Link className="main-logo" to="/">
            <img src={SiteLogo} alt={siteTitle} />
          </Link>
        </div>
        <div className="footer-content">
          <div className="footer-content-column">
            <ul>
              <li>
                <Link className="nav-item" to="/#profession">
                  Professions
                </Link>
              </li>
              <li>
                <Link className="nav-item" to="/#solutions">
                  Solutions
                </Link>
              </li>
              <li>
                <Link className="nav-item" to="/blog/">
                  News
                </Link>
              </li>
              <li>
                <Link className="nav-item" to="/company/about/">
                  About Us
                </Link>
              </li>
              <li>
                <Link className="nav-item" to="/contact/">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-content-column footer-social">
            <a
              className="social-link"
              target="_blank"
              href="https://www.linkedin.com/company/healthshare/"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              className="social-link"
              target="_blank"
              href="https://www.facebook.com/HealthShare/"
            >
              <i className="fab fa-facebook-square"></i>
            </a>
            <a
              className="social-link"
              target="_blank"
              href="https://www.youtube.com/@HealthshareAustralia"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              className="social-link"
              target="_blank"
              href="https://www.instagram.com/healthshareaustralia/"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <div className="footer-content-column footer-privacy">
            <ul className="footer-menu-horizontal">
              <li>
                <Link className="nav-item" to="/privacy-policy/">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link className="nav-item" to="/terms-and-conditions/">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
